<template>
  <div>
    <canvas id="myChart"></canvas>
    <div v-if="chart" v-html="chart.generateLegend()" class="labels"></div>
  </div>
</template>


<script>
  import Chart from 'chart.js';

  export default {
    props: {
      ingredientSchedules: {
        type: Array
      },
    },
    data() {
      return {
        chart: undefined,
        series: {
          labels: [],
          datasets: [{
            label: '% of malt',
            data: [],
            backgroundColor: [
              'rgba(71, 166, 3, 0.8)',
              'rgba(20, 117, 166, 0.8)',
              'rgba(255, 206, 86, 0.2)',
              'rgba(75, 192, 192, 0.2)',
              'rgba(153, 102, 255, 0.2)',
              'rgba(255, 159, 64, 0.2)'
            ],
            borderColor: [
              'rgba(255, 255, 255, 1)',
              'rgba(255, 255, 255, 1)',
              'rgba(255, 255, 255, 1)',
              'rgba(255, 255, 255, 1)',
              'rgba(255, 255, 255, 1)',
              'rgba(255, 255, 255, 1)'
            ],
            hoverBackgroundColor: [
              'rgba(71, 166, 3, 1)',
              'rgba(20, 117, 166, 1)',
              'rgba(255, 206, 86, 0.4)',
              'rgba(75, 192, 192, 0.4)',
              'rgba(153, 102, 255, 0.4)',
              'rgba(255, 159, 64, 0.4)'
            ],
            borderWidth: 3,
            hoverBorderWidth: 3,
            hoverBorderColor: 'rgba(255, 255, 255, 1)'
          }]
        },
      }
    },
    methods: {
      generateLab() {
        return this.chart.generateLegend();
      }
    },
    watch: {
      ingredientSchedules(newVal, oldVal) {
        this.chart.data.labels = newVal.map((item)=>item.name);
        this.chart.data.datasets.forEach((dataset) => {
          dataset.data = newVal.map((item)=>item.percentage);
        });
        this.chart.update();
      }
    },
    mounted() {
      let ctx = document.getElementById('myChart');
      if (this.ingredientSchedules) {
          this.series.labels = this.ingredientSchedules.map((item) => item.name);
          this.series.datasets[0].data = this.ingredientSchedules.map((item) => item.percentage);
      }
      this.chart = new Chart(ctx, {
        type: 'pie',
        data: this.series,
        options: {
          legend: {
            display: false,
          },
          legendCallback: function(chart) {
            var listItems = chart.legend.legendItems.map(function (legendItem) {
              return "<li><i class='legend-color' style='background-color: "+ legendItem.fillStyle +";'></i>" + legendItem.text + "</li>";
            });

            return "<ul>" + listItems.join('') + "</ul>";
          }
        }
      });
    }
  }
</script>

<style lang="scss">
  .labels {
    ul {
      margin: 30px auto 0 auto;
      width: 80%;
      font-size: 12px;
      padding: 0;
      list-style-type: none;
      text-align: center;

      li {
        display: inline-block;
        margin: 0 10px;
      }
    }
    .legend-color {
      display: inline-block;
      height: 12px;
      width: 12px;
      margin-right: 5px;
    }
  }

</style>
